import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {GefConnectionDto} from "../../../../../../core/dtos/gef/gef-connection-dto";
import {BoncfStatutDTO} from "../../../../../../core/dtos/boncf-statut-d-t-o";
import {LookUpComponent} from "../../../../../../shared/ui/lookup/lookup.component";

@Component({
  selector: 'yo-gef-elap-finance-form',
  templateUrl: './gef-elap-finance-form.component.html',
  standalone: false
})
export class GefElapFinanceFormComponent implements OnInit, OnChanges {

  @Input() gefConnection: GefConnectionDto;
  @Input() canModify: boolean;
  @Input() bonCfStatutList: BoncfStatutDTO[] = [];

  @ViewChild('bonCfStatutExportLookup') bonCfStatutExportLookup: LookUpComponent;

  idSelectedBonCfStatutExport: number;
  form: FormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gefConnection']) {
      this.initForm();
    }
  }

  initForm(): void {
    this.idSelectedBonCfStatutExport = this.gefConnection?.properties?.ejProperties?.bonCfStatutExport?.id;
    this.form = new FormGroup({
      codeEtablissement: new FormControl(this.gefConnection?.properties?.codeEtablissement),
      nomClient: new FormControl(this.gefConnection?.properties?.nomClient),
      accessToken: new FormControl(this.gefConnection?.properties?.accessToken),
      codeArticleFraisPort: new FormControl(this.gefConnection?.properties?.codeArticleFraisPort),
      exercice: new FormControl(this.gefConnection?.properties?.exercice),
      dispoAchat: new FormControl(this.gefConnection?.properties?.articleProperties?.dispoAchat),
      compteContrepartie: new FormControl(this.gefConnection?.properties?.articleProperties?.compteContrepartie),
      compteCharge: new FormControl(this.gefConnection?.properties?.articleProperties?.compteCharge),
      compteFNP: new FormControl(this.gefConnection?.properties?.articleProperties?.compteFNP),
      natureAchat: new FormControl(this.gefConnection?.properties?.articleProperties?.natureAchat),
      destinationAchat: new FormControl(this.gefConnection?.properties?.articleProperties?.destinationAchat),
      EJwfEtapeInitiale: new FormControl(this.gefConnection?.properties?.ejProperties?.wfEtapeInitiale),
      EJwfTransition: new FormControl(this.gefConnection?.properties?.ejProperties?.wfTransition),
      SFwfEtapeInitiale: new FormControl(this.gefConnection?.properties?.sfProperties?.wfEtapeInitiale),
      SFwfTransition: new FormControl(this.gefConnection?.properties?.sfProperties?.wfTransition),
    });
  }

  onChangeBonCfStatutExport = ($event: any): void => {
    this.idSelectedBonCfStatutExport = $event;
  }

  buildJsonProperties(): Record<string, any> {
    return {
      codeEtablissement: this.form.controls['codeEtablissement'].value,
      nomClient: this.form.controls['nomClient'].value,
      accessToken: this.form.controls['accessToken'].value,
      codeArticleFraisPort: this.form.controls['codeArticleFraisPort'].value,
      exercice: this.form.controls['exercice'].value,
      articleProperties: {
        dispoAchat: this.form.controls['dispoAchat'].value,
        compteContrepartie: this.form.controls['compteContrepartie'].value,
        compteCharge: this.form.controls['compteCharge'].value,
        compteFNP: this.form.controls['compteFNP'].value,
        natureAchat: this.form.controls['natureAchat'].value,
        destinationAchat: this.form.controls['destinationAchat'].value,
      },
      ejProperties: {
        wfEtapeInitiale: this.form.controls['EJwfEtapeInitiale'].value,
        wfTransition: this.form.controls['EJwfTransition'].value,
        bonCfStatutExport: {
          id: this.bonCfStatutExportLookup?.getSelectedItem()?.id,
          libelle: this.bonCfStatutExportLookup?.getSelectedItem()?.libelle
        } as BoncfStatutDTO
      },
      sfProperties: {
        wfEtapeInitiale: this.form.controls['SFwfEtapeInitiale'].value,
        wfTransition: this.form.controls['SFwfTransition'].value,
      }
    };
  }
}
